import { render, staticRenderFns } from "./ComplianceNotifications.vue?vue&type=template&id=338d2c32&"
import script from "./ComplianceNotifications.vue?vue&type=script&lang=js&"
export * from "./ComplianceNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports